var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSekeronOriginalLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1733.95 727.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-5);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 6.64,
    y1: 165.47,
    x2: 589.58,
    y2: 165.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f60061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#f5145c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f54a4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f59f3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5d32e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 5.25,
    y1: 561.82,
    x2: 617.44,
    y2: 561.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 355.99,
    y1: 136.45,
    x2: 526.9,
    y2: 136.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5d32e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ecd233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#d3d042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#accd5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#75c97c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#2fc4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04c1c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 104.16,
    y1: 367.28,
    x2: 333.92,
    y2: 367.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04c1c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5d32e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 377.96,
    y1: 586.84,
    x2: 537.06,
    y2: 586.84,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 205.08,
    y1: 363.91,
    x2: 377.97,
    y2: 363.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8997db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#638ed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#0479b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078b8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 311.27,
    y1: 363.91,
    x2: 422.68,
    y2: 363.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#0081c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078b8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m780.15,280.63v23.79h-95.18v-23.79h95.18Zm-95.18,95.18v-23.46h83.28v23.46h-83.28Zm23.79,47.59h71.38v23.79h-95.18v-23.88h23.79v.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m968.16,447.19h-31.72l-67.42-73.36v73.36h-23.79v-166.56h23.79v73.36l63.45-73.36h31.72l-73.36,81.54,77.33,85.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1113.07,280.63v23.79h-95.18v-23.79h95.18Zm-95.18,95.18v-23.46h83.28v23.46h-83.28Zm23.79,47.59h71.38v23.79h-95.18v-23.88h23.79v.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1292.98,447.19h-27.76l-41.39-57.51h-26.03v57.5h-23.79v-81.29h59.23c17.35,0,31.97-8.93,31.97-30.49s-14.13-30.98-31.47-30.98h-59.73v-23.79h51.55c43.37,0,63.45,21.81,63.45,53.29,0,25.78-14.13,46.85-38.91,53.54l42.88,59.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1432.73,278.94v23.88c-30.95,3.33-54.68,29.19-54.68,61.09s23.73,57.76,54.68,61.09v23.87c-43.91-3.46-78.47-40.16-78.47-84.96s34.55-81.5,78.47-84.97Zm92.05,84.97c0,44.8-34.56,81.5-78.47,84.96v-23.87c30.95-3.33,54.68-29.19,54.68-61.09s-23.73-57.77-54.68-61.09v-23.88c43.91,3.47,78.47,40.17,78.47,84.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1733.95,280.63v170.52l-138.79-141.67v-32.82l115,117.98v-114.01h23.79Zm-138.79,48.94l23.79,23.92v93.7h-23.79v-117.62Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m556.89,372.26v-24.49c-19.04-4.76-27.49-10.7-27.49-21.78,0-12.98,9.83-21.23,27.49-23.12v-23.8c-33.32,2.96-51.29,22.99-51.29,47.91,0,20.93,11.57,36.84,51.29,45.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m619.37,298.48c-17.34-16.09-38.69-19.14-49.14-19.7v23.95c17.87,1.38,29.81,9.61,37.74,17.31l11.4-21.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m570.23,350.69v24.14c19.9,4.27,32.78,12.17,32.78,24.53,0,14.54-11.58,24.19-32.78,25.71v23.88c35.13-2.26,56.58-23.21,56.58-50.58s-19.05-39.93-56.58-47.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m556.89,424.93c-16.91-2-32.98-10.68-45.09-24.09l-11.9,21.31c2.33,2.8,21.33,24.22,56.99,26.76v-23.98Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 401.32,
    cy: 215.53,
    r: 12.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.66,
    cy: 361.35,
    r: 12.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 330.43,
    cy: 114.91,
    r: 12.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 402.07,
    cy: 505.89,
    r: 12.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 355.14,
    cy: 615.83,
    r: 12.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.64,330.95c-.41,0-.82-.02-1.24-.07-6.03-.68-10.37-6.12-9.69-12.15C27.44,134.74,181.56,0,366.98,0c79.4,0,154.86,25.12,218.2,72.65,4.85,3.64,5.84,10.53,2.2,15.38-3.64,4.86-10.54,5.82-15.38,2.2-59.51-44.65-130.4-68.25-205.02-68.25C192.75,21.98,48.02,148.33,28.54,321.19c-.63,5.61-5.39,9.76-10.91,9.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m366.98,727.82c-91.1,0-178.28-33.83-245.47-95.25C54.75,571.54,13.85,497.52,5.3,407.85c-.58-6.04,3.85-11.4,9.89-11.98,6.1-.54,11.41,3.85,11.98,9.89,8.03,84.24,46.43,153.24,109.16,210.58,63.13,57.71,145.04,89.49,230.65,89.49s168.68-32.23,232.01-90.76c4.46-4.12,11.4-3.85,15.52.61,4.12,4.46,3.85,11.41-.61,15.52-67.4,62.29-155.1,96.59-246.93,96.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m515.91,171.81c-2.26,0-4.54-.69-6.5-2.13-41.5-30.49-90.76-46.61-142.43-46.61-6.07,0-10.99-4.92-10.99-10.99s4.92-10.99,10.99-10.99c56.39,0,110.14,17.59,155.44,50.87,4.89,3.59,5.94,10.47,2.35,15.36-2.15,2.93-5.49,4.48-8.86,4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m322.94,622.51c-.59,0-1.19-.05-1.79-.15-127.48-20.89-216.99-129.07-216.99-258.46,0-115.45,75.17-218.51,185.72-251.4,5.82-1.72,11.93,1.58,13.67,7.4,1.73,5.82-1.58,11.94-7.4,13.67-101.3,30.13-170.01,124.53-170.01,230.33,0,118.57,81.76,217.63,198.57,236.77,5.99.98,10.05,6.63,9.06,12.62-.88,5.39-5.54,9.21-10.83,9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m388.94,625.54c-5.71,0-10.54-4.42-10.95-10.21-.43-6.05,4.13-11.31,10.19-11.74,49.63-3.52,92.34-21.48,130.96-52.98,4.7-3.83,11.61-3.14,15.46,1.57,3.83,4.7,3.13,11.62-1.57,15.46-42.14,34.38-89.13,54.03-143.29,57.87-.27.02-.53.03-.79.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m366.98,525.81c-89.27,0-161.9-72.63-161.9-161.9s72.63-161.9,161.9-161.9c6.07,0,10.99,4.92,10.99,10.99s-4.92,10.99-10.99,10.99c-77.15,0-139.93,62.77-139.93,139.93s62.77,139.93,139.93,139.93c6.07,0,10.99,4.92,10.99,10.99s-4.92,10.99-10.99,10.99Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 366.98,
    cy: 363.91,
    r: 55.7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSekeronOriginalLogo);
export default __webpack_public_path__ + "static/media/ic_sekeron_original_logo.93e5730560aa836844359c8bb7450b7d.svg";
export { ForwardRef as ReactComponent };